/**
 *
 * Spinner
 *
 */

import styled, { keyframes } from 'styled-components';
import { colors } from 'globalStyles';

const scaleout = keyframes`
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1.0);
    opacity: 0;
  }
`;

const Spinner = styled.div`
  width: ${({ size }) => size ? size : '300px'};
  height: ${({ size }) => size ? size : '300px'};
  margin: 0 auto;
  background-color: ${colors.LIGHT_GRAY};
  border-radius: 100%;

  animation: ${scaleout} 1s infinite ease-in-out;
`;

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js